module.exports = __webpack_public_path__ + "media/images/landing/avatar6-fdf6d360847ab6b8375320f56274f059.jpg";